export { default } from "./TableDetail";
